import lottieReact from "lottie-react";
import { cjsDefault } from "../lib/cjs-default";
import Spinner from "../assets/animations/spinner.json";

const Lottie = cjsDefault(lottieReact);

export default function Loader({
  expanded = false,
  style,
}: {
  expanded?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={
        "flex items-center justify-center" +
        (expanded ? " fixed top-0 left-0 w-full h-[100dvh]" : "")
      }
      style={style}
    >
      <Lottie
        animationData={Spinner}
        style={{ height: "30px" }}
        loop
        autoplay
      />
    </div>
  );
}
